var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgErrorRed = function SvgErrorRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.998,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 65.998C50.9493 65.998 65.5 51.4473 65.5 33.498C65.5 15.5488 50.9493 0.998047 33 0.998047C15.0507 0.998047 0.5 15.5488 0.5 33.498C0.5 51.4473 15.0507 65.998 33 65.998ZM21.6058 44.8922C20.5482 43.8346 20.5482 42.1197 21.6058 41.0621L29.1698 33.4981L21.6058 25.9341C20.5481 24.8765 20.5481 23.1616 21.6058 22.104C22.6634 21.0463 24.3783 21.0463 25.4359 22.104L33 29.668L40.5642 22.1038C41.6218 21.0461 43.3367 21.0461 44.3943 22.1038C45.452 23.1615 45.452 24.8763 44.3943 25.934L36.8301 33.4981L44.3943 41.0622C45.4519 42.1199 45.4519 43.8347 44.3943 44.8924C43.3366 45.9501 41.6218 45.9501 40.5641 44.8924L33 37.3283L25.436 44.8922C24.3783 45.9499 22.6635 45.9499 21.6058 44.8922Z",
    fill: "#FF5555"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-red.2928650e.svg";
export { ForwardRef as ReactComponent };